import { useQuery } from '@tanstack/react-query';
import { Search } from 'lucide-react';
import type { AdminLogEntry, Page } from '@hoopify/shared';
import { api, errorMessage } from '../../lib/api';
import { Alert, LoadingBlock } from '../../components/ui';
import { Pager } from '../../components/admin/AdminLayout';
import { LogList, useListParams } from './AdminAccountsPage';

export function AdminLogPage() {
  const { q, page, text, setText, set } = useListParams('all');
  const list = useQuery({
    queryKey: ['admin', 'log', q, page],
    queryFn: () => api.get<Page<AdminLogEntry>>(`/admin/log?q=${encodeURIComponent(q)}&page=${page}`),
    placeholderData: (prev) => prev,
  });
  return (
    <>
      <h1 className="mb-1 text-[24px] font-semibold tracking-[-0.01em]">Admin log</h1>
      <p className="mb-5 text-muted">Every admin sign-in and every change made from this console. It can’t be edited.</p>
      <label className="relative mb-4 block">
        <span className="sr-only">Search the log</span>
        <Search className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted" aria-hidden />
        <input className="field-input pl-9" type="search" value={text} onChange={(e) => setText(e.target.value)} placeholder="Search by name, email, team or reason" />
      </label>
      {list.isError && <Alert>{errorMessage(list.error)}</Alert>}
      {list.isLoading ? <LoadingBlock /> : list.data && (
        <>
          <LogList rows={list.data.rows} empty="Nothing matches." />
          <Pager page={page} total={list.data.total} pageSize={list.data.pageSize} onPage={(p) => set('page', String(p))} />
        </>
      )}
    </>
  );
}
